<template>
 <v-card
   class="ads-card"
   :class="{ 'card-hover': active }"
   elevation="0"
   @mouseover="active = true"
   @mouseleave="active = false"
 >
   <!-- Animated Background -->
   <div class="card-background">
     <div class="gradient-bg"></div>
     <div class="floating-elements">
       <div class="float-element element-1"></div>
       <div class="float-element element-2"></div>
       <div class="float-element element-3"></div>
     </div>
   </div>


   <!-- Header Section -->
   <div class="card-header">
     <div class="header-content">
       <div class="icon-wrapper">
         <v-icon size="28" color="white">mdi-advertisement</v-icon>
       </div>
       <div class="header-text">
         <h2 class="card-title">Advertisement Analytics</h2>
         <p class="card-subtitle">Monitor your advertising content performance</p>
       </div>
     </div>
     <div class="header-badge">
       <v-icon size="16" color="white">mdi-trending-up</v-icon>
       <span>Live</span>
     </div>
   </div>


   <!-- Stats Section -->
   <div class="stats-section">
     <div class="stats-grid">
       <!-- Videos Card -->
       <div
         class="stat-item video-stat"
         @click="goToAds('video')"
         :class="{ 'stat-active': hoveredStat === 'video' }"
         @mouseover="hoveredStat = 'video'"
         @mouseleave="hoveredStat = null"
       >
         <div class="stat-icon-container">
           <div class="stat-icon video-icon">
             <v-icon size="24" color="white">mdi-play-circle</v-icon>
           </div>
           <div class="icon-glow video-glow"></div>
         </div>
         <div class="stat-content">
           <div class="stat-number">{{ getAdsCount.totalVideos }}</div>
           <div class="stat-label">Video Ads</div>
         </div>
         <div class="stat-arrow">
           <v-icon size="20" color="#E91E63">mdi-arrow-right</v-icon>
         </div>
       </div>


       <!-- Images Card -->
       <div
         class="stat-item image-stat"
         @click="goToAds('image')"
         :class="{ 'stat-active': hoveredStat === 'image' }"
         @mouseover="hoveredStat = 'image'"
         @mouseleave="hoveredStat = null"
       >
         <div class="stat-icon-container">
           <div class="stat-icon image-icon">
             <v-icon size="24" color="white">mdi-image</v-icon>
           </div>
           <div class="icon-glow image-glow"></div>
         </div>
         <div class="stat-content">
           <div class="stat-number">{{ getAdsCount.totalImages }}</div>
           <div class="stat-label">Image Ads</div>
         </div>
         <div class="stat-arrow">
           <v-icon size="20" color="#9C27B0">mdi-arrow-right</v-icon>
         </div>
       </div>


       <!-- Total Card -->
       <div
         class="stat-item total-stat"
         @click="goToAds('')"
         :class="{ 'stat-active': hoveredStat === 'total' }"
         @mouseover="hoveredStat = 'total'"
         @mouseleave="hoveredStat = null"
       >
         <div class="stat-icon-container">
           <div class="stat-icon total-icon">
             <v-icon size="24" color="white">mdi-chart-bar</v-icon>
           </div>
           <div class="icon-glow total-glow"></div>
         </div>
         <div class="stat-content">
           <div class="stat-number">{{ getAdsCount.totalAds }}</div>
           <div class="stat-label">Total Ads</div>
         </div>
         <div class="stat-arrow">
           <v-icon size="20" color="#3F51B5">mdi-arrow-right</v-icon>
         </div>
       </div>
     </div>
   </div>


   <!-- Insights Section -->
   <!-- <div class="insights-section">
     <div class="insights-grid">
       <div class="insight-card">
         <div class="insight-icon">
           <v-icon size="20" color="#FF9800">mdi-eye</v-icon>
         </div>
         <div class="insight-content">
           <div class="insight-value">{{ getEngagementRate }}%</div>
           <div class="insight-label">Engagement</div>
         </div>
       </div>
      
       <div class="insight-card">
         <div class="insight-icon">
           <v-icon size="20" color="#4CAF50">mdi-thumb-up</v-icon>
         </div>
         <div class="insight-content">
           <div class="insight-value">{{ getVideoToImageRatio }}%</div>
           <div class="insight-label">Video Ratio</div>
         </div>
       </div>
      
       <div class="insight-card">
         <div class="insight-icon">
           <v-icon size="20" color="#2196F3">mdi-clock-outline</v-icon>
         </div>
         <div class="insight-content">
           <div class="insight-value">{{ getRecentAds }}</div>
           <div class="insight-label">Recent</div>
         </div>
       </div>
     </div>
   </div> -->


   <!-- Action Footer -->
   <div class="card-footer">
     <v-btn
       class="manage-btn"
       variant="outlined"
       size="small"
       @click="goToAds('')"
     >
       <v-icon left size="16">mdi-cog</v-icon>
       Manage Ads
     </v-btn>
    
  
   </div>


   <!-- Loading Overlay -->
   <div v-if="loading" class="loading-overlay">
     <v-progress-circular
       indeterminate
       size="36"
       color="primary"
     ></v-progress-circular>
   </div>
 </v-card>
</template>


<script>
import { mapGetters, mapActions } from "vuex";


export default {
 data() {
   return {
     active: false,
     hoveredStat: null,
     loading: false
   };
 },
  computed: {
   ...mapGetters("adminDashboard", ["getAdsCount"]),
  
   getEngagementRate() {
     // Mock calculation - replace with actual engagement data
     const total = this.getAdsCount.totalAds || 0;
     if (total === 0) return 0;
     return Math.round((this.getAdsCount.totalVideos * 1.2 + this.getAdsCount.totalImages * 0.8) / total * 10);
   },
  
   getVideoToImageRatio() {
     const total = this.getAdsCount.totalAds || 0;
     if (total === 0) return 0;
     return Math.round((this.getAdsCount.totalVideos / total) * 100);
   },
  
   getRecentAds() {
     // Mock calculation - replace with actual recent ads data
     return Math.round((this.getAdsCount.totalAds || 0) * 0.15);
   }
 },
  methods: {
   ...mapActions("adminDashboard", ["fetchAdsCountDetails"]),
  
   async goToAds(type) {
     this.loading = true;
     try {
       await this.$router.push({
         name: "admin-ads",
         query: { type }
       });
     } catch (error) {
       console.error('Navigation error:', error);
     } finally {
       this.loading = false;
     }
   },
  
   createNewAd() {
     // Add your create new ad logic here
     console.log('Create new ad');
   }
 },
  async mounted() {
   this.loading = true;
   try {
     await this.fetchAdsCountDetails();
   } catch (error) {
     console.error('Error fetching ads details:', error);
   } finally {
     this.loading = false;
   }
 }
};
</script>


<style scoped>
.ads-card {
 position: relative;
 border-radius: 20px !important;
 overflow: hidden;
 transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
 background: white;
 border: 1px solid rgba(0, 0, 0, 0.05);
 min-height: 380px;
}


.ads-card.card-hover {
 transform: translateY(-6px);
 box-shadow: 0 16px 40px rgba(0, 0, 0, 0.15);
}


.card-background {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 pointer-events: none;
}


.gradient-bg {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 height: 140px;
  background: linear-gradient(135deg, #a86008 0%, #ffa751 50%, #ffe259 100%);
}


.floating-elements {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
}


.float-element {
 position: absolute;
 border-radius: 50%;
 background: rgb(255 255 255 / 62%);
 animation: float 8s ease-in-out infinite;
}


.element-1 {
 width: 80px;
 height: 80px;
 top: 20px;
 right: 20px;
 animation-delay: 0s;
}


.element-2 {
 width: 60px;
 height: 60px;
 top: 80px;
 right: 100px;
 animation-delay: 2s;
}


.element-3 {
 width: 40px;
 height: 40px;
 top: 40px;
 right: 160px;
 animation-delay: 4s;
}


@keyframes float {
 0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 0.7; }
 50% { transform: translateY(-15px) rotate(180deg); opacity: 1; }
}


.card-header {
 position: relative;
 padding: 24px;
 display: flex;
 align-items: center;
 justify-content: space-between;
 z-index: 1;
}


.header-content {
 display: flex;
 align-items: center;
 gap: 16px;
}


.icon-wrapper {
 width: 52px;
 height: 52px;
 border-radius: 14px;
 background: rgba(255, 255, 255, 0.2);
 display: flex;
 align-items: center;
 justify-content: center;
 backdrop-filter: blur(10px);
}


.header-text {
 color: white;
}


.card-title {
 font-size: 1.4rem;
 font-weight: 700;
 margin: 0 0 4px 0;
}


.card-subtitle {
 font-size: 0.9rem;
 opacity: 0.9;
 margin: 0;
}


.header-badge {
 display: flex;
 align-items: center;
 gap: 6px;
 background: rgba(255, 255, 255, 0.2);
 padding: 8px 12px;
 border-radius: 16px;
 color: white;
 font-size: 0.8rem;
 font-weight: 500;
 backdrop-filter: blur(10px);
}


.stats-section {
 padding: 0 24px;
 position: relative;
 z-index: 1;
 margin-bottom: 20px;
}


.stats-grid {
 display: grid;
 grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
 gap: 16px;
 margin-bottom: 24px;
}


.stat-item {
 background: white;
 border-radius: 16px;
 padding: 20px;
 cursor: pointer;
 transition: all 0.3s ease;
 border: 1px solid rgba(0, 0, 0, 0.06);
 display: flex;
 align-items: center;
 gap: 16px;
 position: relative;
 overflow: hidden;
}


.stat-item:hover {
 transform: translateY(-2px);
 box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}


.stat-item.stat-active {
 border-color: currentColor;
 box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}


.stat-icon-container {
 position: relative;
}


.stat-icon {
 width: 48px;
 height: 48px;
 border-radius: 12px;
 display: flex;
 align-items: center;
 justify-content: center;
 position: relative;
 z-index: 1;
}


.video-icon {
 background: linear-gradient(135deg, #E91E63, #AD1457);
}


.image-icon {
 background: linear-gradient(135deg, #9C27B0, #7B1FA2);
}


.total-icon {
 background: linear-gradient(135deg, #3F51B5, #303F9F);
}


.icon-glow {
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translate(-50%, -50%);
 width: 60px;
 height: 60px;
 border-radius: 50%;
 opacity: 0;
 transition: opacity 0.3s ease;
}


.stat-item:hover .icon-glow {
 opacity: 0.3;
}


.video-glow {
 background: radial-gradient(circle, #E91E63, transparent);
}


.image-glow {
 background: radial-gradient(circle, #9C27B0, transparent);
}


.total-glow {
 background: radial-gradient(circle, #3F51B5, transparent);
}


.stat-content {
 flex: 1;
}


.stat-number {
 font-size: 2rem;
 font-weight: 700;
 line-height: 1;
 margin-bottom: 4px;
 color: #333;
}


.stat-label {
 font-size: 0.9rem;
 color: #666;
 font-weight: 500;
}


.stat-arrow {
 opacity: 0;
 transition: all 0.3s ease;
 transform: translateX(-10px);
}


.stat-item:hover .stat-arrow {
 opacity: 1;
 transform: translateX(0);
}


.insights-section {
 padding: 0 24px 24px;
 position: relative;
 z-index: 1;
}


.insights-grid {
 display: grid;
 grid-template-columns: repeat(3, 1fr);
 gap: 12px;
}


.insight-card {
 background: rgba(0, 0, 0, 0.02);
 border-radius: 12px;
 padding: 16px;
 display: flex;
 align-items: center;
 gap: 12px;
 transition: all 0.3s ease;
}


.insight-card:hover {
 background: rgba(0, 0, 0, 0.04);
}


.insight-icon {
 width: 36px;
 height: 36px;
 border-radius: 8px;
 background: rgba(255, 255, 255, 0.8);
 display: flex;
 align-items: center;
 justify-content: center;
}


.insight-content {
 flex: 1;
}


.insight-value {
 font-size: 1.2rem;
 font-weight: 600;
 color: #333;
 line-height: 1;
}


.insight-label {
 font-size: 0.8rem;
 color: #666;
 margin-top: 2px;
}


.card-footer {
 padding: 16px 24px;
 background: rgba(0, 0, 0, 0.02);
 border-top: 1px solid rgba(0, 0, 0, 0.05);
 display: flex;
 gap: 12px;
 position: relative;
 z-index: 1;
}


.manage-btn {
 border-radius: 12px !important;
 text-transform: none !important;
 font-weight: 500 !important;
 border-color: rgba(0, 0, 0, 0.1) !important;
}


.create-btn {
 background: linear-gradient(135deg, #E91E63, #9C27B0) !important;
 color: white !important;
 border-radius: 12px !important;
 text-transform: none !important;
 font-weight: 500 !important;
 box-shadow: 0 4px 12px rgba(233, 30, 99, 0.3) !important;
}


.create-btn:hover {
 transform: translateY(-1px);
 box-shadow: 0 6px 16px rgba(233, 30, 99, 0.4) !important;
}


.loading-overlay {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(255, 255, 255, 0.8);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 10;
 backdrop-filter: blur(2px);
}


/* Responsive Design */
@media (max-width: 768px) {
 .stats-grid {
   grid-template-columns: 1fr;
 }
  .insights-grid {
   grid-template-columns: 1fr;
 }
  .card-footer {
   flex-direction: column;
 }
  .stat-item {
   padding: 16px;
 }
}


@media (max-width: 600px) {
 .card-header {
   padding: 20px;
   flex-direction: column;
   gap: 16px;
   align-items: flex-start;
 }
  .stats-section,
 .insights-section {
   padding: 0 20px 20px;
 }
  .card-footer {
   padding: 16px 20px;
 }
  .insight-card {
   padding: 12px;
 }
  .stat-number {
   font-size: 1.6rem;
 }
}
</style>

